export const SchoolIdealTypeLogEvent = {
  HOME_SOCIAL_CONTENT_SCHOOL_IDEAL_TYPE_CLICKED: {
    amp: 'Home - School Ideal Type Clicked',
    ga: 'home_shcool_ideal_type_click',
  },
  SCHOOL_IDEAL_TYPE_ONBOARDING_VIEWED: {
    amp: 'School Ideal Type Onboarding - Viewed',
    ga: 'school_ideal_type_onboarding_viewed',
  }, // [온보딩] 화면 진입
  SCHOOL_IDEAL_TYPE_ONBOARDING_HOME_BUTTON_CLICKED: {
    amp: 'School Ideal Type Onboarding - Home Button Clicked',
    ga: 'school_ideal_type_onboarding_home_button_clicked',
  }, // [온보딩] 홈버튼 클릭
  SCHOOL_IDEAL_TYPE_ONBOARDING_PARTICIPATE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Onboarding - Participate Button Clicked',
    ga: 'school_ideal_type_onboarding_participate_button_clicked',
  }, // [온보딩] 참여하기 버튼 클릭
  SCHOOL_IDEAL_TYPE_ONBOARDING_SHARE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Onboarding - Share Button Clicked',
    ga: 'school_ideal_type_onboarding_share_button_clicked',
  }, // [온보딩] 공유 버튼 클릭
  SCHOOL_IDEAL_TYPE_ONBOARDING_LOGIN_MODAL_VIEWED: {
    amp: 'School Ideal Type Onboarding - Login Modal Viewed',
    ga: 'school_ideal_type_onboarding_login_modal_viewed',
  }, // [온보딩] 로그인 모달 진입
  SCHOOL_IDEAL_TYPE_ONBOARDING_LOGIN_BUTTON_CLICKED: {
    amp: 'School Ideal Type Onboarding - Login Button Clicked',
    ga: 'school_ideal_type_onboarding_login_button_clicked',
  }, // [온보딩] 로그인 버튼 클릭
  SCHOOL_IDEAL_TYPE_INFO_INPUT_VIEWED: {
    amp: 'School Ideal Type Info Input - Viewed',
    ga: 'school_ideal_type_info_input_viewed',
  }, // [신청 정보 입력] 화면 진입
  SCHOOL_IDEAL_TYPE_INFO_INPUT_NEXT_BUTTON_CLICKED: {
    amp: 'School Ideal Type Info Input - Next Button Clicked',
    ga: 'school_ideal_type_info_input_next_button_clicked',
  }, // [신청 정보 입력] 다음 버튼 클릭
  SCHOOL_IDEAL_TYPE_TOTAL_INFO_INPUT_RESULT_PARTICIPATE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Total Info Input Result - Participate Button Clicked',
    ga: 'school_ideal_type_total_info_input_result_participate_button_clicked',
  }, // [총 입력 결과] 신청하기 버튼 클릭
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_VIEWED: {
    amp: 'School Ideal Type Participate Result - Viewed',
    ga: 'school_ideal_type_participate_result_viewed',
  }, // [신청 결과] 화면 진입
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_SHARE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Participate Result - Share Button Clicked',
    ga: 'school_ideal_type_participate_result_share_button_clicked',
  }, // [신청 결과] 공유 버튼 클릭
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_ALARM_BUTTON_CLICKED: {
    amp: 'School Ideal Type Participate Result - Alarm Button Clicked',
    ga: 'school_ideal_type_participate_result_alarm_button_clicked',
  }, // [신청 결과] 알림 버튼 클릭
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_HOME_BUTTON_CLICKED: {
    amp: 'School Ideal Type Participate Result - Home Button Clicked',
    ga: 'school_ideal_type_participate_result_home_button_clicked',
  }, // [신청 결과] 홈 버튼 클릭
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_PROFILE_BUTTON_CLICK: {
    amp: 'School Ideal Type Participate Result - Profile Button Click',
    ga: 'school_ideal_type_participate_result_profile_button_click',
  }, // [신청 결과] 내 프로필 클릭
  SOULMATE_PROFILE_INPUT_MBTI_VIEWED: {
    amp: 'Soulmate Profile Input Mbti - Viewed',
    ga: 'soulmate_profile_input_mbti_viewed',
  }, // [프로필 입력 - MBTI] 화면 진입
  SOULMATE_PROFILE_INPUT_MBTI_NEXT_BUTTON_CLICKED: {
    amp: 'Soulmate Profile Input Mbti - Next Button Clicked',
    ga: 'soulmate_profile_input_mbti_next_button_clicked',
  }, // [프로필 입력 - MBTI] 테스트 시작 버튼 클릭
  SOULMATE_PROFILE_INPUT_MBTI_LIST_VIEWED: {
    amp: 'Soulmate Profile Input Mbti - List Viewed',
    ga: 'soulmate_profile_input_mbti_list_viewed',
  }, // [프로필 입력 - MBTI] 목록 화면 진입
  SOULMATE_PROFILE_INPUT_MBTI_QUIZ_CLICKED: {
    amp: 'Soulmate Profile Input Mbti - Quiz Clicked',
    ga: 'soulmate_profile_input_mbti_quiz_clicked',
  }, // [프로필 입력 - MBTI] 퀴즈 클릭
  SOULMATE_PROFILE_INPUT_IDEAL_VIEWED: {
    amp: 'Soulmate Profile Input Ideal - Viewed',
    ga: 'soulmate_profile_input_ideal_viewed',
  }, // [프로필 입력 - 이상형] 화면 진입
  SOULMATE_PROFILE_INPUT_IDEAL_NEXT_BUTTON_CLICKED: {
    amp: 'Soulmate Profile Input Ideal - Next Button Clicked',
    ga: 'soulmate_profile_input_ideal_next_button_clicked',
  }, // [프로필 입력 - 이상형] 내 이상형 알아내기 버튼 클릭
  SOULMATE_PROFILE_INPUT_IDEAL_LIST_VIEWED: {
    amp: 'Soulmate Profile Input Ideal - List Viewed',
    ga: 'soulmate_profile_input_ideal_list_viewed',
  }, // [프로필 입력 - 이상형] 목록 화면 진입
  SOULMATE_PROFILE_INPUT_IDEAL_QUIZ_CLICKED: {
    amp: 'Soulmate Profile Input Ideal - Quiz Clicked',
    ga: 'soulmate_profile_input_ideal_quiz_clicked',
  }, // [프로필 입력 - 이상형] 퀴즈 클릭

  //[스테이징] 화면 진입
  SCHOOL_IDEAL_TYPE_STAGING_VIEWED: {
    amp: 'School Ideal Type Staging - Viewed',
    ga: 'school_ideal_type_staging_viewed',
  },
  //[신청 결과] 유형 정보 입력하기 클릭
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_INPUT_INFO_BUTTON_CLICKED: {
    amp: 'School Ideal Type Participate Result - Input Information Button Clicked',
    ga: 'school_ideal_type_participate_result_input_info_button_clicked',
  },
  //[신청 결과] 프로필 수정 클릭
  SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_UPDATE_PROFILE_CLICKED: {
    amp: 'School Ideal Type Participate Result - Update Profile Clicked',
    ga: 'school_ideal_type_participate_result_update_profile_clicked',
  },

  //[뽑기] 화면 진입
  SCHOOL_IDEAL_TYPE_ROULETTE_SCREEN_VIEWED: {
    amp: 'School Ideal Type Roulette - Screen Viewed',
    ga: 'school_ideal_type_roulette_screen_viewed',
  },

  //[뽑기] 뽑기 버튼 클릭
  SCHOOL_IDEAL_TYPE_ROULETTE_ROULETTE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Roulette - Roulette Button Clicked',
    ga: 'school_ideal_type_roulette_roulette_button_clicked',
  },
  //[뽑기] 뽑기 성공
  SCHOOL_IDEAL_TYPE_ROULETTE_ROULETTE_SUCCESS: {
    amp: 'School Ideal Type Roulette - Roulette Success',
    ga: 'school_ideal_type_roulette_roulette_success',
  },
  //[뽑기] 뽑기 실패
  SCHOOL_IDEAL_TYPE_ROULETTE_ROULETTE_FAIL: {
    amp: 'School Ideal Type Roulette - Roulette Fail',
    ga: 'school_ideal_type_roulette_roulette_fail',
  },
  //[뽑기] 공유 버튼 클릭
  SCHOOL_IDEAL_TYPE_ROULETTE_SHARE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Roulette - Share Button Clicked',
    ga: 'school_ideal_type_roulette_share_button_clicked',
  },
  //[뽑기] 프로필 클릭
  SCHOOL_IDEAL_TYPE_ROULETTE_PROFILE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Roulette - Profile Button Clicked',
    ga: 'school_ideal_type_roulette_profile_button_clicked',
  },
  //[뽑기] 끝까지 기다리고 결과로 이동
  SCHOOL_IDEAL_TYPE_ROULETTE_WAIT_ROULETTE_ANIMATION: {
    amp: 'School Ideal Type Roulette - Wait Roulette Animation',
    ga: 'school_ideal_type_roulette_wait_roulette_animation',
  },
  //[뽑기] staging 중 카드 클릭해서 바로 결과로 이동
  SCHOOL_IDEAL_TYPE_ROULETTE_CARD_CLICKED_ON_ANIMATION: {
    amp: 'School Ideal Type Roulette - Card Clicked On Animation',
    ga: 'school_ideal_type_roulette_card_clicked_on_animation',
  },
  //[프로필] 화면 진입
  SCHOOL_IDEAL_TYPE_PROFILE_SCREEN_VIEWED: {
    amp: 'School Ideal Type Profile - Screen Viewed',
    ga: 'school_ideal_type_profile_screen_viewed',
  },
  //[프로필] 프로필 편집 클릭
  SCHOOL_IDEAL_TYPE_PROFILE_UPDATE_PROFILE_CLICKED: {
    amp: 'School Ideal Type Profile - Update Profile Clicked',
    ga: 'school_ideal_type_profile_update_profile_clicked',
  },
  //[프로필] 유형 정보 수정 클릭
  SCHOOL_IDEAL_TYPE_PROFILE_UPDATE_PERSONALITY_CLICKED: {
    amp: 'School Ideal Type Profile - Update Personality Clicked',
    ga: 'school_ideal_type_profile_update_personality_clicked',
  },
  //[프로필]  유형 정보 등록 클릭
  SCHOOL_IDEAL_TYPE_PROFILE_INPUT_PERSONALITY_CLICKED: {
    amp: 'School Ideal Type Profile - Input Personality Clicked',
    ga: 'school_ideal_type_profile_input_personality_clicked',
  },
  //[프로필 편집] 화면 진입
  SCHOOL_IDEAL_TYPE_PROFILE_UPDATE_SCREEN_VIEWED: {
    amp: 'School Ideal Type Profile Update - Screen Viewed',
    ga: 'school_ideal_type_profile_update_screen_viewed',
  },
  //[프로필 편집] 저장 클릭
  SCHOOL_IDEAL_TYPE_PROFILE_SAVE_BUTTON_CLICKED: {
    amp: 'School Ideal Type Profile - Save Button Clicked',
    ga: 'school_ideal_type_profile_save_button_clicked',
  },
  //[뽑기] (웹)앱으로 결과보기 모달 진입
  SCHOOL_IDEAL_TYPE_ROULETTE_APP_MODAL_VIEWED: {
    amp: 'School Ideal Type Roulette - App Modal Viewed',
    ga: 'school_ideal_type_roulette_app_modal_viewed',
  },
  //[뽑기] (웹)앱에서 보기 클릭
  SCHOOL_IDEAL_TYPE_ROULETTE_APP_BUTTON_CLICKED: {
    amp: 'School Ideal Type Roulette - App Button Clicked',
    ga: 'school_ideal_type_roulette_app_button_clicked',
  },
  //[뽑기] (웹)버릴래요 클릭
  SCHOOL_IDEAL_TYPE_ROULETTE_DISCARD_BUTTON_CLICKED: {
    amp: 'School Ideal Type Roulette - Discard Button Clicked',
    ga: 'school_ideal_type_roulette_discard_button_clicked',
  },
  //[뽑기] (웹)결과 볼래요 클릭
  SCHOOL_IDEAL_TYPE_ROULETTE_RESULT_BUTTON_CLICKED: {
    amp: 'School Ideal Type Roulette - Result Button Clicked',
    ga: 'school_ideal_type_roulette_result_button_clicked',
  },
  //[신청 정보 입력] 졸업생 모달 진입
  SCHOOL_IDEAL_TYPE_INFO_INPUT_GRADUATE_MODAL_VIEWED: {
    amp: 'School Ideal Type Info Input - Graduate Modal Viewed',
    ga: 'school_ideal_type_info_input_graduate_modal_viewed',
  },
}
